import { render, staticRenderFns } from "./SmsMessageTemplate.vue?vue&type=template&id=19ae4b64&scoped=true"
import script from "./SmsMessageTemplate.vue?vue&type=script&lang=js"
export * from "./SmsMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./SmsMessageTemplate.vue?vue&type=style&index=0&id=19ae4b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ae4b64",
  null
  
)

export default component.exports